import get from 'lodash/get';
import { LOG_IN_SUCCEEDED, SIGN_UP_SUCCEEDED } from '../redux/account';

import type {
  EventTracking,
  LoginSucceeded,
  SignUpSucceeded,
  Store,
} from '../types';

/** @type {ActionType} */
export const pbr_log_out_requested = 'pbr_log_out_requested';

/** @type {ActionType} */
export const pbr_reset_password_succeeded = 'pbr_reset_password_succeeded';

/** @type {ActionType} */
export const pbr_log_in_succeeded = 'pbr_log_in_succeeded';

/** @type {ActionType} */
export const pbr_sign_up_succeeded = 'pbr_sign_up_succeeded';

function logInSucceeded(action: LoginSucceeded, state: Store): Object {
  return {
    id: get(action, 'payload.method'),
  };
}

function signUpSucceeded(action: SignUpSucceeded, state: Store): Object {
  return {
    id: get(action, 'payload.method'),
  };
}

// Make sure you cast this before you export it in your duckling.
const tracking: EventTracking = {};
tracking[LOG_IN_SUCCEEDED] = logInSucceeded;
tracking[SIGN_UP_SUCCEEDED] = signUpSucceeded;

export default tracking;
